import {
  GET_CONSTANTS_SUCCESS,
  SUPPORT_CHAT_SOUND,
  UNREAD_CHAT_COUNT_ADMIN,
  SET_FORUM_READ_TOPICS,
  UNREAD_ERX_OFFLINE_COUNT,
  DOCTOR_AND_NURSE_LIST,
  SUPPORT_STAFF,
    CONSULT_NATURE_LIST, SET_FORUM_READ_COMMENTS, SET_TICKET_COUNT
} from "../constants/serverConstants";

const initialState = {
    constants: null,
    isMuted: false,
    unreadChatCountAdmin: 0,
    forumReadTopics: 0,
    unreadErxOfflineCount: 0,
    tickitCounts: 0,
    doctorAndNurseList: [],
    consultNatureList: [],
    supportTickets: [],
    supportStaff: []
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_CONSTANTS_SUCCESS:
            return {
                ...state,
                constants: action.payload
            };
        case SUPPORT_CHAT_SOUND:
            return {
                ...state,
                isMuted: action.payload
            }
        case UNREAD_CHAT_COUNT_ADMIN:
            return {
                ...state,
                unreadChatCountAdmin: action.payload
            }
        case SET_FORUM_READ_TOPICS:
            return {
              ...state,
              forumReadTopics: action.payload
            };
        case SET_FORUM_READ_COMMENTS:
            return {
              ...state,
              forumReadComments: action.payload
            };
        case SET_TICKET_COUNT:
            return {
              ...state,
                tickitCounts: action.payload
            };
        case UNREAD_ERX_OFFLINE_COUNT:
            return {
                ...state,
                unreadErxOfflineCount: action.payload
            };
        case SUPPORT_STAFF:
            return {
                ...state,
                supportStaff: action.payload
            };
        case DOCTOR_AND_NURSE_LIST:
            return {
                ...state,
                doctorAndNurseList: action.payload.sort((a, b)=> {
                    return a.firstName + a.lastName > b.firstName + b.lastName? 0 : -1
                })
            };
        case CONSULT_NATURE_LIST:
            return {
                ...state,
                consultNatureList: action.payload
            };
        default:
            return state;
    }
}
